<template>
  <div>
    <ListItemFilters
      icon="ui-icon-clinic"
      :title="lpuFiltersState.lpuType?.name || t('Тип клиники', options)"
      :subtitle="lpuFiltersState.lpuType ? t('Тип клиники', options) : ''"
      @click="openDialog"
    />

    <LpuTypeModal
      :value="isDialogOpened"
      is-back
      @lpu-type:selected="onClickLpuType"
      @input="handleCloseLpuTypeModal"
    >
      <template #footer="{ selectedLpuType }">
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedLpuType"
            @click="handleLpuTypeSelected(selectedLpuType)"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </LpuTypeModal>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/lpu/functions/deepEqual'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import LpuTypeModal from 'www/vue_components/common/TheFilters/lpu/components/LpuTypeFilters/components/LpuTypeModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: lpuFiltersState } = toRefs(props)

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemLpuType')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const hasUnsavedLpuType = computed(() => (
  !deepEqual(lpuFiltersState.value.lpuType, filtersStore.unsavedFilters.lpuType)
))

const handleCloseLpuTypeModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(lpuFiltersState.value)
}

const onClickLpuType = (lpuType: Filters['lpuType']) => {
  filtersStore.updateUnsavedFilters({ lpuType })
}

const handleLpuTypeSelected = (lpuType: Filters['lpuType']) => {
  closeDialog()

  filtersStore.updateUnsavedFilters({ lpuType })
  emit('input', filtersStore.unsavedFilters)
}
</script>
